var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPause = function SvgPause(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06.-Health-Screens\\uD83D\\uDC8A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1801_DeletionRequest",
    transform: "translate(-1376.000000, -429.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(240.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(0.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy",
    transform: "translate(20.000000, 124.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions",
    transform: "translate(1090.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(26.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0005122,4.22290145 C18.0093738,5.13196261 21,8.71512571 21,13 C21,17.9725 16.9725,22 12,22 C7.0275,22 3,17.9725 3,13 C3,8.71477054 5.99112202,5.13136858 10.0004848,4.22267545 L10.0004041,6.28947612 C7.10795927,7.14939664 5,9.82739583 5,13 C5,16.8675 8.1325,20 12,20 C15.8675,20 19,16.8675 19,13 C19,9.82776042 16.8925252,7.15001213 14.000593,6.28977265 L14.0005122,4.22290145 Z M10.0000027,8.41568336 L10,10 C10,10.5128358 10.3860402,10.9355072 10.8833789,10.9932723 L11,11 L13,11 C13.5128358,11 13.9355072,10.6139598 13.9932723,10.1166211 L14,10 L14.0009908,8.41611729 C15.766746,9.18754285 17,10.949088 17,13 C17,15.7625 14.7625,18 12,18 C9.2375,18 7,15.7625 7,13 C7,10.9487034 8.2337166,9.18688212 10.0000027,8.41568336 Z M12,2 C12.5522847,2 13,2.44771525 13,3 L13,9 C13,9.55228475 12.5522847,10 12,10 C11.4477153,10 11,9.55228475 11,9 L11,3 C11,2.44771525 11.4477153,2 12,2 Z",
    id: "Combined-Shape",
    fill: "#8F9BA9"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPause, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pause.0b0e9aac.svg";
export { ForwardRef as ReactComponent };